export default "__VITE_ASSET__e99f2cc9__"